import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Contact } from '../../../domain/customerContact/Contact';
import { ContactRepository } from '../../../infrastructure/repositories/customer-contacts/contactRepository';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { AppContext } from '../../../main/context/Provider';
import { ContactForm } from '../components/form/ContactsForm';

export const UpdateContactPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const [contact, setContact] = useState<Contact>();
    const { id } = useParams<{ id: string }>();

    const { webPage } = changeWebPageTitleService(
        isSkinSmart,
        'Actualizar Contacto'
    );

    useEffect(() => {
        if (id) {
            ContactRepository.GetContact(id).then((response) => {
                setContact(response);
                setNestedRoutes([
                    {
                        label: 'Contactos',
                        route: `/customers/contacts/contacts-list/${response?.customerId}`,
                    },
                    {
                        label: webPage,
                        route: `/customers/contacts/update-contact/${id}`,
                    },
                ]);
            });
        }
    }, [id, lang, setNestedRoutes, webPage]);

    return (
        <>
            {contact != null && (
                <ContactForm isNewContact={false} contact={contact} />
            )}
        </>
    );
};
